import { useRoute } from '#imports'
import { computed } from 'vue'

// Keeps the last non-empty value of a route param so leaving the page (params
// cleared mid-transition) doesn't change the fetch key and refetch, blanking it.
export function useStickyRouteParam(name: string) {
  const route = useRoute()

  return computed<string>((previous) => {
    const value = route.params[name]

    return value ? String(value) : (previous ?? '')
  })
}
